module.exports = __webpack_public_path__ + "static/media/caret_down.9f9a1477.svg";